import { render, staticRenderFns } from "./addxyf.vue?vue&type=template&id=7e56cbaa&scoped=true"
import script from "./addxyf.vue?vue&type=script&lang=js"
export * from "./addxyf.vue?vue&type=script&lang=js"
import style0 from "./addxyf.vue?vue&type=style&index=0&id=7e56cbaa&prod&lang=less&scoped=true"
import style1 from "./addxyf.vue?vue&type=style&index=1&id=7e56cbaa&prod&lang=css"
import style2 from "./addxyf.vue?vue&type=style&index=2&id=7e56cbaa&prod&lang=less&scoped=true"
import style3 from "./addxyf.vue?vue&type=style&index=3&id=7e56cbaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e56cbaa",
  null
  
)

export default component.exports